/**
 * Opens and closes the collapsible navigation of the header. Any click outside the toggler closes
 * the navigation while it is open, and so does the Escape key, which returns the focus to the
 * toggler.
 * @param {Document} root Document holding the navigation
 */
export default function initNavbar(root = document) {
  const toggler = root.querySelector('.navbar-toggler'),
    target = toggler && root.querySelector(toggler.dataset.target);

  if (!target) {
    return;
  }

  const isOpen = () => toggler.getAttribute('aria-expanded') === 'true',
    showNavbar = (show) => {
      toggler.setAttribute('aria-expanded', show ? 'true' : 'false');
      target.classList.toggle('show', show);
    };

  toggler.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopImmediatePropagation();

    showNavbar(!isOpen());
  });

  root.body.addEventListener('click', () => {
    if (isOpen()) {
      showNavbar(false);
    }
  });

  root.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && isOpen()) {
      showNavbar(false);
      toggler.focus();
    }
  });
}
